<template>

    <main class="ministry-detail">

        <div
            v-if="!ministry"
            class="ministry-detail__not-found"
        >

            <div class="container">

                <h1>
                    Ministry not found
                </h1>

            </div>

        </div>

        <template v-else>

            <section class="ministry-detail__hero">

                <div class="container">

                    <div class="ministry-detail__hero-grid">

                        <div class="ministry-detail__content">

                            <span class="ministry-detail__eyebrow">
                                MINISTRY
                            </span>

                            <h1>
                                {{ ministry.title }}
                            </h1>

                            <div
                                v-if="ministry.content_alt"
                                class="ministry-detail__summary"
                            >

                                <vue-marked>
                                    {{ ministry.content_alt }}
                                </vue-marked>

                            </div>

                        </div>

                        <div
                            v-if="ministry.imagenes_id"
                            class="ministry-detail__image"
                        >

                            <img
                                :src="ministry.imagenes_id | imageIdToURL"
                                :alt="ministry.title"
                            >

                        </div>

                    </div>

                </div>

            </section>

            <section class="ministry-detail__body">

                <div class="container">

                    <article class="ministry-detail__article">

                        <vue-marked>
                            {{ ministry.content }}
                        </vue-marked>

                    </article>

                </div>

            </section>

        </template>

    </main>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'MinistryDetail',

    computed: {
        ...mapGetters([
            'catalogPortfolioContent'
        ]),

        ministry() {
            const id =
                String(
                    this.$route.params.id || ''
                );

            if (
                !Array.isArray(
                    this.catalogPortfolioContent
                )
            ) {
                return null;
            }

            return this.catalogPortfolioContent.find(
                item =>
                    String(item.id) === id
            ) || null;
        }
    },

    watch: {
        ministry: {
            immediate: true,

            handler(value) {
                document.title =
                    'PIB Vallarta | ' +
                    (
                        value?.title ||
                        'Ministry'
                    );
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.ministry-detail {
    min-height: 100vh;

    background:
        #f8f8f6;
}

.container {
    width: 100%;
    max-width: 1200px;

    margin: 0 auto;
}

.ministry-detail__not-found {
    min-height: 80vh;

    display: flex;
    align-items: center;
    justify-content: center;

    padding:
        140px 20px 80px;

    text-align: center;
}

.ministry-detail__hero {
    padding:
        150px 20px
        80px;

    background:
        #262626;
}

.ministry-detail__hero-grid {
    display: grid;

    grid-template-columns:
        1fr;

    gap:
        40px;

    align-items: center;
}

.ministry-detail__eyebrow {
    display: block;

    margin-bottom: 14px;

    color:
        var(--primary);

    font-size:
        .75rem;

    font-weight:
        700;

    letter-spacing:
        2px;

    text-transform:
        uppercase;
}

.ministry-detail__content {
    h1 {
        margin:
            0 0
            20px;

        color:
            #fff;

        font-family:
            'Cormorant Garamond',
            serif;

        font-size:
            clamp(
                3rem,
                8vw,
                5rem
            );

        font-weight:
            600;

        line-height:
            .98;
    }
}

.ministry-detail__summary {
    max-width:
        650px;

    ::v-deep p {
        margin:
            0;

        color:
            rgba(
                255,
                255,
                255,
                .7
            );

        font-size:
            1rem;

        line-height:
            1.8;
    }
}

.ministry-detail__image {
    overflow: hidden;

    img {
        display: block;

        width: 100%;

        aspect-ratio:
            16 / 9;

        object-fit:
            cover;
    }
}

.ministry-detail__body {
    padding:
        70px 20px
        100px;
}

.ministry-detail__article {
    max-width:
        900px;

    margin:
        0 auto;

    ::v-deep h2 {
        margin:
            45px 0
            18px;

        color:
            var(--text);

        font-family:
            'Cormorant Garamond',
            serif;

        font-size:
            2.4rem;

        line-height:
            1.1;
    }

    ::v-deep h2:first-child {
        margin-top: 0;
    }

    ::v-deep h3 {
        margin:
            35px 0
            14px;

        color:
            var(--primary);

        font-size:
            1.15rem;

        font-weight:
            700;
    }

    ::v-deep p {
        margin:
            0 0
            22px;

        color:
            #5f5f5f;

        font-size:
            1rem;

        line-height:
            1.9;
    }

    ::v-deep ul,
    ::v-deep ol {
        margin:
            20px 0;

        padding-left:
            25px;

        color:
            #5f5f5f;

        line-height:
            1.8;
    }

    ::v-deep li {
        margin-bottom:
            8px;
    }

    ::v-deep strong {
        color:
            var(--text);
    }

    ::v-deep blockquote {
        margin:
            35px 0;

        padding:
            25px 30px;

        border-left:
            4px solid
            var(--primary);

        background:
            #fff;

        color:
            var(--text);

        font-family:
            'Cormorant Garamond',
            serif;

        font-size:
            1.4rem;

        line-height:
            1.6;
    }
}

@media (min-width: 900px) {
    .ministry-detail__hero {
        padding:
            170px 30px
            100px;
    }

    .ministry-detail__hero-grid {
        grid-template-columns:
            minmax(0, .9fr)
            minmax(0, 1.1fr);

        gap:
            70px;
    }

    .ministry-detail__body {
        padding:
            90px 30px
            120px;
    }
}
</style>
